module.exports = __webpack_public_path__ + "static/media/lift2.9ccfe90e.png";